// extracted by mini-css-extract-plugin
module.exports = {"categoriesList":"categories_categoriesList__oIEue","categoryName":"categories_categoryName__p1rIr","SMALL":"categories_SMALL__ljgjZ","white":"categories_white__ursPF"};